// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 400px;
  height: 400px;
  position: relative;
}

h1 {
  color: #333;
  margin-bottom: 20px;
}

input[type="file"] {
  margin-bottom: 10px;
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

ul {
  list-style: none;
  margin: 10px 0;
  padding: 0;
}

li {
  background-color: #f9f9f9;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 5px;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  display: block;
  width: 100%;
  margin-top: 10px;
}

button:hover {
  background-color: #0056b3;
}

input[type="text"] {
  width: 100%;
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
}

.error {
  color: #ff0000;
  background-color: #ffe6e6;
  padding: 10px;
  border: 1px solid #ff0000;
  border-radius: 4px;
  margin-top: 10px;
  text-align: center;
  width: 100%;
}

.success {
  color: #008000;
  background-color: #e6ffe6;
  padding: 10px;
  border: 1px solid #008000;
  border-radius: 4px;
  margin-top: 10px;
  text-align: center;
  width: 100%;
}

.success a {
  color: #008000;
  font-weight: bold;
  text-decoration: none;
}

.success a:hover {
  text-decoration: underline;
}

.tag-input-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}

.tag-input {
  display: flex;
  width: 100%;
}

.tag-input input[type="text"] {
  flex: 1 1;
  padding: 15px;
  margin: 0;
  border: 2px solid #ddd;
  border-radius: 4px 0 0 4px;
  height: 44px;
  width: calc(100% - 100px);
}

.tag-input button {
  height: 44px;
  width: 100px;
  padding: 0 15px;
  margin: 0;
  border-radius: 0 4px 4px 0;
  border: 2px solid #007bff;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  box-sizing: border-box;
}

.suggested-tags-container {
  margin-bottom: 15px;
  display: block;
}

.suggested-tags {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
  max-height: 150px;
  overflow-y: auto;
}

.suggested-tags li {
  border: 1px solid #007bff;
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  cursor: pointer;
  margin: 5px;
  transition: background-color 0.3s, transform 0.2s;
}

.suggested-tags li:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.tags-list-container {
  margin-bottom: 15px;
  display: block;
}

.tags-list {
  display: flex;
  flex-wrap: wrap;
}

.tags-list li {
  border: 1px solid #6c757d;
  background-color: #6c757d;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  cursor: pointer;
  margin: 5px;
  transition: background-color 0.3s;
}

.tags-list li:hover {
  background-color: #5a6268;
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/Upload.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: Arial, sans-serif;\n  background-color: #f5f5f5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.container {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 400px;\n  height: 400px;\n  position: relative;\n}\n\nh1 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\ninput[type=\"file\"] {\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nul {\n  list-style: none;\n  margin: 10px 0;\n  padding: 0;\n}\n\nli {\n  background-color: #f9f9f9;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 5px;\n}\n\nbutton {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  display: block;\n  width: 100%;\n  margin-top: 10px;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\ninput[type=\"text\"] {\n  width: 100%;\n  padding: 10px;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 10px;\n}\n\n.error {\n  color: #ff0000;\n  background-color: #ffe6e6;\n  padding: 10px;\n  border: 1px solid #ff0000;\n  border-radius: 4px;\n  margin-top: 10px;\n  text-align: center;\n  width: 100%;\n}\n\n.success {\n  color: #008000;\n  background-color: #e6ffe6;\n  padding: 10px;\n  border: 1px solid #008000;\n  border-radius: 4px;\n  margin-top: 10px;\n  text-align: center;\n  width: 100%;\n}\n\n.success a {\n  color: #008000;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.success a:hover {\n  text-decoration: underline;\n}\n\n.tag-input-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.tag-input {\n  display: flex;\n  width: 100%;\n}\n\n.tag-input input[type=\"text\"] {\n  flex: 1;\n  padding: 15px;\n  margin: 0;\n  border: 2px solid #ddd;\n  border-radius: 4px 0 0 4px;\n  height: 44px;\n  width: calc(100% - 100px);\n}\n\n.tag-input button {\n  height: 44px;\n  width: 100px;\n  padding: 0 15px;\n  margin: 0;\n  border-radius: 0 4px 4px 0;\n  border: 2px solid #007bff;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  box-sizing: border-box;\n}\n\n.suggested-tags-container {\n  margin-bottom: 15px;\n  display: block;\n}\n\n.suggested-tags {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n  background-color: #f0f0f0;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.suggested-tags li {\n  border: 1px solid #007bff;\n  background-color: #007bff;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 20px;\n  cursor: pointer;\n  margin: 5px;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.suggested-tags li:hover {\n  background-color: #0056b3;\n  transform: scale(1.05);\n}\n\n.tags-list-container {\n  margin-bottom: 15px;\n  display: block;\n}\n\n.tags-list {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.tags-list li {\n  border: 1px solid #6c757d;\n  background-color: #6c757d;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 20px;\n  cursor: pointer;\n  margin: 5px;\n  transition: background-color 0.3s;\n}\n\n.tags-list li:hover {\n  background-color: #5a6268;\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
